import { doPost2WithFormData, doGet2 } from "./common"

const getInstantWin = async (id) => {
    const response = await doGet2(`/instant-win/${id}`, {})
    const data = await response.json()
    return data;
}


// using "payload" here is not very readable. doing this just to get going.
// update this to explicitly list params, e.g. ({breakId, stepId, instantWinId, })
const qualifyingEvent = (payload) => {
// export const qualifyingEvent = ({breakId, stepId, instantWinId, event="not set"}) => {
      
    // const payload = {
    //     breakId: breakId,
    //     stepId: stepId,
    //     instantWinId: parseInt(instantWinId, 10),
    //     event: event,
    // }
      
    return doPost2WithFormData(`/instant-win-qualify`, payload)
    
}

    
const createEntry = (instantWinId, token, email) => {
  
    const payload = {
        instantWinId: instantWinId,
        token: token,
        email: email
    }

    return doPost2WithFormData(`/instant-win-entry`, payload)

}

export { getInstantWin, qualifyingEvent, createEntry }